import { useState } from 'react';
import { t } from 'ttag';
import  classNames from 'classnames';

import { Switch } from '@ui/Switch';
import { Modal } from '@ui/Modal';
import { Link } from '@ui/Link';
import {
  DeliverySettingForm,
  FormData,
} from '@components/settings/DeliverySettingForm';
import { DeliveryService } from '@newModels';

import s from './ShopSettingsDeliveryMethod.sss';

type OrderRegion = {
  id: string;
  name: string;
};
type OrderCity = OrderRegion;
type OrderWarehouse = OrderRegion;

export type ChangedData = {
  isEnabled: boolean;
  region?: OrderRegion | null;
  city?: OrderCity | null;
  warehouse?: OrderWarehouse | null;
};

type CommonProps = {
  name: string;
  description: string;
  deliveryService: DeliveryService;
  isEnabled: boolean;
  isHidden: boolean
  isHiddenDescription?: string | null
  icon: string;
  onChange: (arg1: ChangedData) => void;
};

export type MinimalisticThemeProps = {
  theme: 'minimalistic'
};

export type FullThemeProps = {
  theme: 'full'
  region?: OrderRegion | null;
  city?: OrderCity | null;
  warehouse?: OrderWarehouse | null;
};

export type ShopSettingsDeliveryMethodProps = CommonProps & (
  MinimalisticThemeProps | FullThemeProps
);

export const ShopSettingsDeliveryMethod: React.FC<ShopSettingsDeliveryMethodProps> = ({
  name,
  description,
  deliveryService,
  isEnabled,
  isHidden,
  isHiddenDescription,
  icon,
  onChange,
  ...props
}) => {
  const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);

  const onSubmitSettingForm = (formData: FormData) => {
    const {
      region,
      city,
      warehouse,
    } = formData;

    onChange({
      isEnabled,
      region: region && { id: region.value, name: region.label },
      city: city && { id: city.value, name: city.label },
      warehouse: warehouse && { id: warehouse.value, name: warehouse.label },
    });

    setIsSettingModalOpen(false);
  };

  return (
    (
      <div className={classNames(s.root, { [s.themeFull]: props.theme === 'full' })}>
        <div className={s.deliveryInfo}>
          <img className={s.deliveryIcon} src={icon} alt="..." />
          <div className={s.deliveryBlock}>
            <p className={s.deliveryName}>
              {name}
            </p>

            {
            props.theme === 'full' && (
              <>
                <div className={s.deliveryCurrency}>
                  {description.split('\n').map(
                    (line, i) => <div key={i} className={s.descriptionLine}>{line}</div>,
                  )}
                </div>
                <Link
                  onClick={() => setIsSettingModalOpen(true)}
                  disabled={true}
                >
                  {t`Редагувати`}
                </Link>
              </>
            )
          }

            {isHiddenDescription && (
            <p className={s.isHiddenDescription}>
              {isHiddenDescription}
            </p>
            )}
          </div>
        </div>
        <Switch
          className={s.switch}
          checked={isEnabled}
          onChange={() => onChange({ isEnabled: !isEnabled })}
          disabled={isHidden}
        />
        {
        props.theme === 'full' && (
          <Modal
            isOpen={isSettingModalOpen}
            onRequestClose={() => setIsSettingModalOpen(false)}
          >
            <DeliverySettingForm
              deliveryService={deliveryService}
              initialData={props}
              onCancel={() => setIsSettingModalOpen(false)}
              onSubmit={onSubmitSettingForm}
            />
          </Modal>
        )
      }
      </div>
    )
  );
};
